import React from "react";
import {
  BADGE_DESCRIPTIONS,
  BOOLEAN_FIELDS,
  badgeClassForToken,
} from "./courtedConstants";

const usedTokens = new Set();
Object.values(BOOLEAN_FIELDS).forEach((field) => {
  usedTokens.add(field.badgeToken);
  if (field.badgeTokenNo) {
    usedTokens.add(field.badgeTokenNo);
  }
});

// BADGE_DESCRIPTIONS insertion order drives display order.
export const ColorLegendTooltip = () => (
  <div>
    {Object.entries(BADGE_DESCRIPTIONS)
      .filter(([token]) => usedTokens.has(token))
      .map(([token, info]) => (
        <div key={token} className="d-flex align-items-center mb-1">
          <span className={`${badgeClassForToken(token)} mr-1`}>
            {info.label}
          </span>
          <span>{info.description}</span>
        </div>
      ))}
  </div>
);

export default ColorLegendTooltip;
